import { Component, OnInit, Renderer2, ViewChild } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { AuthService } from 'src/app/services/auth.service';
import { UserService } from '../../../../services/user.service';
import { CustomValidators } from 'ng2-validation';
import { CommonService } from '../../../../services/common.service';
import { environment } from 'src/environments/environment';
import { maxYearFunction } from '../../../../_helpers/utility';
import { MustMatch } from '../../../../_helpers/must-match.validator';

//import * as moment from 'moment';
import { TokenStorageService } from 'src/app/services/token-storage.service';
import * as moment from 'moment-timezone';
@Component({
  selector: "app-verification",
  templateUrl: "./dob-verification.component.html",
  styleUrls: ["./dob-verification.component.scss"],
  providers: [ConfirmationService, MessageService],
  
})

export class DobVerification implements OnInit {
  activeIndex: number = -1;
  selectedValue: string = '';
  showSameEmail = true;


  showOtpmodal: boolean = false;
  thankYouModal: boolean = false;
  under18: boolean = true;
  above18: boolean = false;
  id;
  userForm: FormGroup;
  userFormAbove18: FormGroup;
  passwordform: FormGroup;
  deleteAccountForm: FormGroup;
  submittedPassword = false;

  emailadamin;
  submitted = false;
  uploadedFiles: any[] = [];
  file: File;
  reader: FileReader;
  public profilepic;
  errorMessage = '';
  public item: any[] = [];
  countrylist: any = [];
  statelist: any = [];
  citylist: any = [];
  genders: any = [];
  public imageProfile;
  public phoneNumber;
  showProfile = false;
  statuses: any = [];
  userstatus: any;
  usergender: any;
  selectedStatus: any;
  countryname;
  countrycode;
  statename;
  statecode;
  cityname;
  citycode;
  dob: Date;
  bDate;
  showProfileUpdateMesage;
  dobdt: Date;
  yearRange;
  public defaultDate: Date = new Date(environment.defaultDate);
   minYear = environment.minYear;
  minYearRange = new Date(environment.minYear);
  timeZoneArray = [];
  timeZoneOffset;
  timeZone;
  cpassword: boolean;
  newPasswordCheck: boolean;
  newPasswordDisable: boolean;
  public imageSize = environment.imageSize;
  public otp: string;
  public config = {
      allowNumbersOnly: true,
      length: 6,
      isPasswordInput: false,
      disableAutoFocus: false,
      required: true,
      placeholder: '',
      inputStyles: {
          'width': '50px',
          'height': '50px'
      }
  };
  public loggedInUser;
  public isLoggedIn: boolean;
  public userId;
  public profileDetails;
  public showGenderRequired: boolean = false;
  public showOtpErrors: boolean = false;
  public showOtpErrorsMsg: boolean = false;
  public showResendButton: boolean = false;
  public otpErrorMessage;
  public displayTime;
  public isVerified: boolean = false;
  public reasonList: any = [];
  public submittedDeleteAccount: boolean = true;
  public showMessageInput: boolean = false;
  selectedReason: any;
  public videoForm: FormGroup;
  public videoUploadedFiles: any[] = [];
  public userVideo;
  public showVideoError: boolean = false;
  public selectedPlayerVideo;
  public isVideoApproved: boolean = false;
  public contactVideoApproved: boolean = false;
  rejectedVideoListPresent: boolean = false;
  rejectedVideoList: any;
  isProfileComplete: boolean = false;
  tooltipContent: string;
  public userCategories = environment.userCategories;
  rolearray: any;
  userCategory;
  selectedRoleid;
  maxYear: any;
  ref_id: any;
  aadharSuccessMesssageCheck:boolean = false;
  @ViewChild('ngOtpInput') ngOtpInput:any;
  doSubmitData:boolean = true;
  doSendOtp: boolean = false;
  aadharSuccessMesssage: any = '';
    page: any;
  constructor(private userService: UserService, private commonService: CommonService, private formBuilder: FormBuilder,
      private renderer: Renderer2,
      private confirmationService: ConfirmationService, private messageService: MessageService,
      private router: Router, private activeroute: ActivatedRoute, private authService: AuthService, private tokenStorage: TokenStorageService, private userservice: UserService) { }

  ngOnInit(): void {
    this.activeroute.queryParams.subscribe((value)=>{
        this.above18 = (value.isAbout18 === 'true') ? true : false;
        this.page = value.page;
    })
      this.renderer.addClass(document.body, 'dob_body');
      this.loggedInUser = this.tokenStorage.getUser();
      this.rolearray = this.tokenStorage.getRolelist();
      if (this.loggedInUser.userdata != undefined) {
          this.isLoggedIn = true;
          this.userId = this.loggedInUser.userdata.id;
      }
      if (this.isLoggedIn == false) {
          this.router.navigate(['/']);
      }
      const timeZones = moment.tz.names();
      for (const timezone of timeZones) {
          this.timeZoneArray.push({ name: timezone, code: moment().tz(timezone).format('Z') });
      }
      this.defaultDate.setDate(this.defaultDate.getDate() - 5);
      this.yearRange = this.minYear + ":" + maxYearFunction();
      this.maxYear = moment().subtract(5, 'years').toDate();
      //this.id = this.activeroute.snapshot.params.id;
      this.id = this.userId;
      this.statuses = [
          { label: 'Active', value: true },
          { label: 'In-Active', value: false }
      ];
      this.genders = [
          { name: 'Male', code: 'Male' },
          { name: 'Female', code: 'Female' },
          { name: 'Other', code: 'Other' },
      ];
      this.getUserDetails(this.id);
    //   this.getCountry();
      this.userForm = this.formBuilder.group({
          //   firstName: ['', [Validators.required, Validators.pattern('^[A-Za-z][A-Za-z]*$')] ],
          //   lastName: ['', [Validators.required, Validators.pattern('^[A-Za-z][A-Za-z]*$')]],
          parentFirstName: ['', {
              validators: [Validators.required, Validators.pattern('[A-Za-z][A-Za-z]*$')]
          }],
          parentLastName: ['', {
              validators: [Validators.required, Validators.pattern('[A-Za-z][A-Za-z]*$')]
          }],
          sameAsUserEmail: [true, Validators.required],
        //   parentEmail: ['', [Validators.required, Validators.email, Validators.pattern('^[a-z]+(\.[a-z0-9]+)?@[a-z0-9]+\.(com|in|org|net|edu|gov|mil|co\.[a-z]{2})$')]],
          parentEmail: ['', [Validators.required, Validators.email, CustomValidators.email]],
          // password: ['', [Validators.required, Validators.minLength(6)]],
          parentPanNumber: ['', [Validators.required,Validators.pattern('^[A-Z0-9]+$'),Validators.maxLength(10)]],
        //   panDetails: ['', {
        //     validators: [Validators.required, Validators.pattern('[A-Za-z][A-Za-z]*$')]
        // }],
        aadharNumber: ['', {
          validators: [Validators.required, Validators.min(100000000000),Validators.max(999999999999)]
        }],
        parentConsentForAadhar: ['',[Validators.required]]
        //   country: ['', Validators.required],
        //   state: ['', Validators.required],
        //   city: ['', Validators.required],
        //   zipcode: ['', Validators.required],
        //   status: [''],
        //   gender: ['', {
        //       validators: [Validators.required]
        //   }],
        //   dob: ['', {
        //       validators: [Validators.required]
        //   }]
      });
      
      this.userFormAbove18 = this.formBuilder.group({
        aadharNumber: ['', {
            validators: [Validators.required, Validators.min(100000000000),Validators.max(999999999999)]
          }],
      })
    //   this.userCategories.forEach(element => {
    //       this.userForm.addControl(element.slug, new FormControl());
    //   })
      this.passwordform = this.formBuilder.group({
          currentPassword: ['', [Validators.required]],
          password: ['', {
              validators: [Validators.required, Validators.pattern("^(?=[^A-Z\n]*[A-Z])(?=[^a-z\n]*[a-z])(?=[^0-9\n]*[0-9])(?=[^#?!@$%^&*\n-]*[#?!@$%^&*-]).{6,}$")], updateOn: 'blur'
          }],
          confirmPassword: ['', Validators.required],
      }, {
          validator: MustMatch('password', 'confirmPassword')
      });
      this.reasonList = [
          { id: 1, label: 'Not happy with us.' },
          { id: 2, label: 'Get another application.' },
          { id: 3, label: 'Not easy to use.' },
          { id: 4, label: 'Other' },
      ];
      this.deleteAccountForm = this.formBuilder.group({
          reason: ['', [Validators.required]],
          message: [''],
      });

      this.videoForm = this.formBuilder.group({
          //youtubevideourl: ['', Validators.required],

      });
  }
  ngOnDestroy() {
      this.renderer.removeClass(document.body, 'dob_body');
    }
  get deleteReqForm() {
      return this.deleteAccountForm.controls;
  }
  // newPassword(event) {
  //     if (this.passwordform.controls['password'].value != '' && this.passwordform.controls['currentPassword'].value == '') {
  //         this.passwordform.controls['currentPassword'].setValidators([Validators.required]);
  //         this.cpassword = true;
  //         this.newPasswordCheck = false;
  //     } else {
  //         this.cpassword = false;
  //     }
  // }
  // newPasswordValidation(event) {
  //     this.passwordform.get('password').enable()
  //     this.passwordform.get('confirmPassword').enable()
  //     if (this.passwordform.controls['currentPassword'].value != '' && this.userForm.controls['password'].value == '') {
  //         this.passwordform.controls['password'].setValidators([Validators.pattern("^(?=[^A-Z\n]*[A-Z])(?=[^a-z\n]*[a-z])(?=[^0-9\n]*[0-9])(?=[^#?!@$%^&*\n-]*[#?!@$%^&*-]).{6,}$")]);
  //         this.newPasswordCheck = true;
  //         this.cpassword = false;
  //     } else {
  //         this.newPasswordCheck = false;
  //     }
  // }

  picUploader(event) {
      for (let file of event.files) {
          this.uploadedFiles.push(file);
          var reader = new FileReader();
          reader.readAsDataURL(this.uploadedFiles[0]);
          reader.onload = () => { // called once readAsDataURL is completed
              this.profilepic = reader.result;
          }
      }
  }
  public countryName;
  public countryCode;

  getStates(fromForm, event) {
      this.citylist = [];


      if (fromForm == "true") {
          this.userForm.get('zipcode').reset();
          this.countrycode = event.value.code;
          this.countryname = event.value.name;
          this.statecode = "";
          this.statename = "";
          this.citycode = "";
          this.cityname = "";
      } else {
          this.countrycode = "IN";
      }

      this.commonService.getStateList(this.countrycode).subscribe(
          data => {
              this.statelist = data.data.items;
          },
          err => {
            //   this.errorMessage = err.error.message;
          }
      );
  }
  onGenderSelect(event) {
      if (event) {
          this.usergender = event.name;
      }
  }

  getCities(fromForm, event) {

      if (fromForm == "true") {
          this.userForm.get('zipcode').reset();
          this.statecode = event.value.code;
          this.statename = event.value.name;
          this.userForm.controls.city.setValue('');
      } else {
          this.statecode = event;
      }


      this.commonService.getCityList(this.statecode).subscribe(
          data => {
              this.citylist = data.data.items;
          },
          err => {
            //   this.errorMessage = err.error.message;
          }
      );
  }
  onOtpChange(otp) {
      this.otp = otp;
  }
  getUserDetails(id) {
      this.userService.getUserDetails(id).subscribe(
          data => {
              this.item = data;
              if (data.isMobileVerified == true) {
                  this.isVerified = true
              }
              if (this.item) {
                  this.getStates("false", this.item['countrycode']);
                //   this.userForm.get('country').setValue({ name: this.item['countryname'], code: this.item['countrycode'] });
                  if (this.item['statecode']) {
                      this.getCities("false", this.item['statecode']);
                    //   this.userForm.get('state').setValue({ name: this.item['statename'], code: this.item['statecode'] });
                  }
                  if (this.item['citycode']) {
                    //   this.userForm.get('city').setValue({ name: this.item['cityname'], code: this.item['citycode'] });
                  }
                  if (this.item['gender']) {
                    //   this.userForm.get('gender').setValue({ name: this.item['gender'], code: this.item['gender'] });
                  }
                  //   var bDate = moment(this.item['dob'], 'DD-MM-YYYY');
                  this.isProfileComplete = this.item['isProfileComplete']
                  if (this.isProfileComplete == false) {
                      this.tooltipContent = "Please complete your profile to upload video"
                  }
                  //   this.bDate = bDate.format('DD-MM-YYYY');
                  this.userForm.patchValue({
                    // parentFirstName: this.item['firstName'],
                    // parentLastName: this.item['lastName'],
                    parentEmail: this.item['email'],
                    //   mobileNumber: this.item['mobileNumber'],
                      // country: this.item['country'],
                      // state: this.item['state'],
                      // city: this.item['city'],
                //       zipcode: this.item['zipcode'],
                //       address: this.item['address'],
                //       dob: this.item['dob'],
                  });
                  this.userForm.get('parentEmail').disable();
                  this.phoneNumber = this.item['mobileNumber']
                  this.countrycode = this.item['countrycode'];
                  this.countryname = this.item['countryname'];
                  this.statecode = this.item['statecode'];
                  this.statename = this.item['statename'];
                  this.citycode = this.item['citycode'];
                  this.cityname = this.item['cityname'];
                  this.selectedPlayerVideo = this.item['playervideoClip'];

                  if (!this.item['isplayerVideoApproved'] && this.selectedPlayerVideo != "") {
                      this.isVideoApproved = true;
                  } else {
                      this.isVideoApproved = false;
                  }

                  if (this.item['isplayerVideoApproved'] && this.selectedPlayerVideo != "") {
                      this.contactVideoApproved = true;
                  } else {
                      this.contactVideoApproved = false;
                  }
                  // console.log(this.statecode);
                  // console.log(this.statename);
                  // console.log(this.citycode);
                  // console.log(this.cityname);
                  var statusobj;
                  //   if (this.item['status'] == true) {
                  //       statusobj = { label: 'Active', value: true };
                  //   } else {
                  //       statusobj = { label: 'In-Active', value: false };
                  //   }
                  //   this.userForm.get('status').setValue(statusobj);

                  if (this.item['profilepic'] != undefined) {
                      this.imageProfile = this.item['profilepic'];
                      this.showProfile = true;
                  } else {
                      this.showProfile = false;
                  }
              }
              this.emailadamin = this.item['count'] >= 2 ? 'support@tplsport.com.' : null;
              this.showProfileUpdateMesage = this.item['count'] >= 2 ? 'If you are unable to update your address, email admin at' : null

              if (this.item['count'] >= 2) {
                  this.userForm.get('country').disable();
                  this.userForm.get('state').disable();
                  this.userForm.get('city').disable();
                  this.userForm.get('zipcode').disable();
                  this.userForm.get('address').disable();
              }
            //   if (this.item['email'] === null) {
            //       this.userForm.get('parentEmail').enable();
            //   } else {
            //       this.userForm.get('parentEmail').disable();
            //   }
              // this.userForm.get('password').disable()
              // this.userForm.get('confirmPassword').disable()
              if (this.item["rejectedReasons"]) {
                  if (this.item["rejectedReasons"].length > 0) {
                      this.rejectedVideoListPresent = true
                      this.rejectedVideoList = this.item["rejectedReasons"]

                  }

              }
            //   if (this.item['rolename']) {

            //       this.userCategories.forEach(element => {
            //           let obj = { name: element.name, value: element.value, status: false, slug: element.slug };
            //           if (element.slug == this.item['rolename']) {
            //               const index = this.findIndexBySlug(element.value, this.userCategories);
            //               obj = { name: element.name, value: element.value, slug: element.slug, status: true };
            //               this.userCategories[index] = obj;
            //               this.userForm.get(element.slug).setValue(obj);
            //           }
            //       })
            //   }

          },
          err => {
            //   this.errorMessage = err.error.message;
          }
      );
  }
  findIndexBySlug(slug, arrayName) {
      let index = -1;
      for (let i = 0; i < arrayName.length; i++) {
          if (arrayName[i].slug === slug) {
              index = i;
              break;
          }
      }
      return index;
  }
  onCategorySelect(userCategory, event) {

      this.userCategory = '';
      if (event.isTrusted) {
          this.userCategory = userCategory.value;

          this.userCategories.forEach(element => {
              let obj = { name: element.name, value: element.value, status: element.status, slug: element.slug };
              if (this.userCategory == element.value) {
                  const index = this.findIndexByValue(element.value, this.userCategories);
                  obj = { name: element.name, value: element.value, status: true, slug: element.slug };
                  this.userCategories[index] = obj;
                  this.userForm.get(element.slug).setValue(obj);
                  const roleindex = this.findIndexByRole(element.slug, this.rolearray);
                  this.selectedRoleid = this.rolearray[roleindex]['roleid'];
              } else {
                  const index = this.findIndexByValue(element.value, this.userCategories);
                  obj = { name: element.name, value: element.value, status: false, slug: element.slug };
                  this.userCategories[index] = obj;
              }
          });
      }
  }
  findIndexByValue(value, arrayName) {
      let index = -1;
      for (let i = 0; i < arrayName.length; i++) {
          if (arrayName[i].value === value) {
              index = i;
              break;
          }
      }
      return index;
  }
  findIndexByRole(value, arrayName) {
      let index = -1;
      for (let i = 0; i < arrayName.length; i++) {
          if (arrayName[i].rolename === value) {
              index = i;
              break;
          }
      }
      return index;
  }

  get f() {
    if(this.above18) {
        return this.userFormAbove18.controls;
    } else {
        return this.userForm.controls;
    }
  }
  backLink() {
      this.router.navigate(['/profile-info']);
  }

  onAadharNumberInput() {
        this.errorMessage = '';
  }

  showotpModal() {
   this.submitted = true;
   if(this.userForm.invalid && !this.above18) {
       return;
   }
   if(this.userFormAbove18.invalid && this.above18) {
    return;
   }
    const aadharNumber = {};
    aadharNumber['aadhaarCardNumber'] = (!this.above18) ? this.userForm.get('aadharNumber').value : this.userFormAbove18.get('aadharNumber').value;

    this.userService.generateOtpForAadharVerification(aadharNumber).subscribe(
        data => {
            this.ref_id = data['reference_id'];
            this.showOtpmodal = true;
        },
        err => {
              this.errorMessage = err.error.error;
        }
    );
  }

  onClickOtpSubmit() {
    if (this.otp == undefined || this.otp.length < 6) {
        this.showOtpErrors = true;
        // setTimeout(() => {
        //   this.showOtpErrors = false;
        // }, 5000);
        return;
    }
    let otpData = {
        'otp': this.otp,
        'ref_id': this.ref_id,
        'userId': this.id
    }
    this.userService.verifyOtpForAadharVerification(otpData).subscribe(
        data => {
          this.aadharSuccessMesssage = data['message'];
          this.aadharSuccessMesssageCheck = true;
          this.doSubmitData = false;
          this.showOtpmodal = false;
        },
        ((err) => {
            this.showOtpErrorsMsg = true;
            this.otpErrorMessage = err.error.error;
        })
    );
}

hideOtpDialog() {
  this.showOtpErrorsMsg = false;
  for(let i=0; i<6; i++) {
      this.ngOtpInput.otpForm.get('ctrl_'+i).setValue(null);
  }
}
  removeFile(event) {
      this.uploadedFiles = [];
      this.profilepic = "{{imageProfile}}";
  }

  onCitySelect(event) {
      this.cityname = event.value.name;
      this.citycode = event.value.code;
      this.userForm.get('zipcode').reset();
  }
  onClickClose() {
    this.thankYouModal = false;
    setTimeout(() => {
        if(this.page) {
            if(this.page === 'tournaments') {
                this.router.navigate(['/tournaments']);
            } else if(this.page.startsWith('tournaments/factsheet')) {
                this.router.navigate([this.page]);
            } else if(this.page === 'find-partner') {
                this.router.navigate(['/find-partner']);
            } else if(this.page === 'contest') {
                this.router.navigate(['/contest']);
            } else if(this.page === 'home') {
                this.router.navigate(['/home']);
            } 
        } else {
            this.router.navigate(['/home']);
        }
    }, 500);
  }
    onSubmit() {
      this.submitted = true;
    if(this.userForm.invalid && !this.above18) {
        return;
    }
    if(this.userFormAbove18.invalid && this.above18) {
     return;
    }
      var userData = (!this.above18) ? this.userForm.value : this.userFormAbove18.value;
      if(!this.above18) {
          var panCardInfo = {};
          panCardInfo['userId'] = this.id;
          panCardInfo['panCardNumber'] = this.userForm.value.parentPanNumber;
          panCardInfo = JSON.stringify(panCardInfo, null, 4);
          this.userService.panCardVerification(panCardInfo).subscribe((data)=>{
            if(data) {
                userData['isProfileComplete'] = true;
                userData['isDobVerified'] = true;
                userData = JSON.stringify(userData, null, 4);
                this.userService.updateUser(this.id, userData).subscribe(
                    data => {
                        this.thankYouModal = true;
                        let userData = this.loggedInUser;
                        this.tokenStorage.removeUser();
                        userData.userdata.isProfileComplete = data.data.isProfileComplete;
                        this.tokenStorage.saveUser(userData);
                        // return;
                        this.messageService.add({ key: 'toastmsg', severity: 'success', summary: 'Successful', detail: 'DOB Verified Successfully!', life: 6000 });
                    },
                    err => {
                           this.messageService.add({ key: 'toastmsg', severity: 'error', summary: "Error", detail: err.error.message, life: 6000 });
                    }
                );
            }
          },(error)=>{
            //  this.errorMessage = error.error.message;
            this.messageService.add({ key: 'toastmsg', severity: 'error', summary: "Error", detail: error.error.error, life: 6000 });
          });
      } else {
                userData['isProfileComplete'] = true;
                userData = JSON.stringify(userData, null, 4);
                this.userService.updateUser(this.id, userData).subscribe(
                    data => {
                        this.thankYouModal = true;
                        let userData = this.loggedInUser;
                        this.tokenStorage.removeUser();
                        userData.userdata.isProfileComplete = data.data.isProfileComplete;
                        this.tokenStorage.saveUser(userData);
                        // return;
                        this.messageService.add({ key: 'toastmsg', severity: 'success', summary: 'Successful', detail: 'DOB Verified Successfully!', life: 6000 });
                    },
                    err => {
                           this.messageService.add({ key: 'toastmsg', severity: 'error', summary: "Error", detail: err.error.error, life: 6000 });
                    }
                );
      }

  }

  onSelectCheckBox(event) {
    this.doSendOtp = event.checked;
  }

  onReasonSelect(event) {
      if (event.value.id === 4) {
          this.showMessageInput = true;
      } else {
          this.showMessageInput = false;
      }
      this.selectedReason = event.value.label;
  }
  submitDeleteAccount() {
      this.submittedDeleteAccount = true;
      if (this.deleteAccountForm.invalid) {
          return;
      }
      var deleteAccountReqData = this.deleteAccountForm.value;
      deleteAccountReqData['reason'] = this.selectedReason;
      deleteAccountReqData = JSON.stringify(deleteAccountReqData, null, 4);
      this.userService.deleteAccountRequest(deleteAccountReqData).subscribe(
          data => {
              this.messageService.add({ key: 'toastmsg', severity: 'success', summary: 'Successful', detail: 'Delete Account Request send to admin Successfully!. Account will be delete within 48 hrs', life: 6000 });
          },
          err => {
              //   this.errorMessage = err.error.message;
          }
      );
  }
  timer(minute) {
      // let minute = 1;
      let seconds: number = minute * 60;
      let textSec: any = "0";
      let statSec: number = 60;

      const prefix = minute < 10 ? "0" : "";

      const timer = setInterval(() => {
          seconds--;
          if (statSec != 0) statSec--;
          else statSec = 59;

          if (statSec < 10) {
              textSec = "0" + statSec;
          } else textSec = statSec;
          if (this.showOtpmodal == true) {
              this.displayTime = `${prefix}${Math.floor(seconds / 60)}:${textSec}`;
          } else {
              clearInterval(timer);
          }
          if (seconds == 0) {
              clearInterval(timer);
              this.showResendButton = true;
          }
      }, 1000);
  }
  onMobilePhoneSubmit(mode) {

      console.log("mobileotp")

      if (mode != "resend") {
          this.submitted = true;

      }
      this.authService.generateMobileOtp(this.phoneNumber).subscribe(
          res => {
              this.showResendButton = false;
              this.timer(5);
          }, err => {
              console.log(err)
          });
  }
  resendOtp() {
      let mode = 'resend';
      this.onMobilePhoneSubmit(mode);
  }
 

  onReset() {
      this.submitted = false;
      this.userForm.reset();
  }


  //=========security-form-control=================\\

  get h() {
      return this.passwordform.controls;
  }

  changepassword() {
      this.submittedPassword = true;
      if (this.passwordform.invalid) {
          return;
      }
      var passworddata = this.passwordform.value;
      passworddata = JSON.stringify(passworddata, null, 4);
      this.updatepassword(passworddata);
  }
  updatepassword(passworddata) {
      this.userservice.updateUser(this.id, passworddata).subscribe(
          () => {
              this.messageService.add({ key: 'toastmsg', severity: 'success', summary: 'Successful', detail: 'Password Updated Successfully', life: 6000 });
              setTimeout(() => {
                  this.router.navigate(['/profile-info']);
              }, 2000);
              this.uploadedFiles = [];
          },
          ((err) => {
              this.messageService.add({ key: 'toastmsg', severity: 'error', summary: err.error.message, detail: 'Password Update failed', life: 6000 });
          })
      );
  }

  videoUploader(event) {
      let index = 0;
      for (let file of event.files) {
          this.videoUploadedFiles.push(file);
          let reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => {
              // called once readAsDataURL is completed
              if (reader.result != null) {
                  //this.sponsorImage.push({ 'file': reader.result });
                  this.userVideo = reader.result;
                  index++;
              }
          }
      }
  }
  removeVideoFile(event) {
      this.videoUploadedFiles = [];
      //this.profilepic = "{{imageProfile}}";
  }
  onSubmitvideo() {
      ///this.submitted = true;
      if (this.videoUploadedFiles.length <= 0) {
          this.showVideoError = true;
          return;
      } else {
          this.showVideoError = false;
      }

      let videoData = this.videoForm.value;
      videoData['playervideo'] = this.userVideo;
      //console.log(videoData);

      //videoData['teamId'] = this.teamId;
      // if (this.isVideoAdd) {
      //   videoData = JSON.stringify(videoData, null, 4);
      //   this.addTeamVideo(videoData);
      // } else {
      //   videoData = JSON.stringify(videoData, null, 4);
      //   this.updateVideo(this.teamVideoId, videoData);
      // }
      videoData = JSON.stringify(videoData, null, 4);
      this.userservice.updateUser(this.id, videoData).subscribe(
          () => {
              this.messageService.add({ key: 'toastmsg', severity: 'success', summary: 'Successful', detail: 'Player Video Clip Uploaded Successfully', life: 6000 });
              setTimeout(() => {
                  this.router.navigate(['/profile-info']);
              }, 2000);
              this.uploadedFiles = [];
              this.videoForm.reset();
              this.videoUploadedFiles = [];
          },
          ((err) => {
              this.messageService.add({ key: 'toastmsg', severity: 'error', summary: err.error.message, detail: 'Password Update failed', life: 6000 });
          })
      );
  }
  addTeamVideo(videoData) {
      // this.teamVideoService.addTeamVideo(videoData).subscribe(
      //   data => {
      //     this.messageService.add({ key: 'toastmsg', severity: 'success', summary: 'Successful', detail: 'Team video added successfully.', life: 6000 });
      //     setTimeout(() => {
      //       this.router.navigate(['/manage/teamdetails/addmedia'], { queryParams: { teamId: this.teamId } });
      //     }, 2000);
      //     this.showvideo = false;
      //     this.videoForm.reset();
      //     this.teamVideo = '';
      //     this.videoUploadedFiles = [];
      //     this.getTeamVideos();
      //   },
      //   err => {
      //     this.messageService.add({ key: 'toastmsg', severity: 'error', summary: 'Error', detail: err.error.message, life: 6000 });
      //   }
      // );
  }
  updateVideo(teamVideoId, videoData) {
      // this.teamVideoService.updateTeamVideo(teamVideoId, videoData).subscribe(
      //   data => {
      //     this.messageService.add({ key: 'toastmsg', severity: 'success', summary: 'Successful', detail: 'Team video updated successfully.', life: 6000 });
      //     setTimeout(() => {
      //       this.router.navigate(['/manage/teamdetails/addmedia'], { queryParams: { teamId: this.teamId } });
      //     }, 2000);
      //     this.showvideo = false;
      //     this.videoForm.reset();
      //     this.teamVideo = '';
      //     this.videoUploadedFiles = [];
      //     this.getTeamVideos();
      //   },
      //   err => {
      //     this.messageService.add({ key: 'toastmsg', severity: 'error', summary: 'Error', detail: err.error.message, life: 6000 });
      //   }
      // )
  }
  toggleAccordion() {
      this.activeIndex = this.activeIndex === 0 ? -1 : 0;
  }
  toggleEmailDiv() {
    this.showSameEmail = this.userForm.controls['sameAsUserEmail'].value;
    this.userForm.controls['parentEmail'].setValue((this.showSameEmail) ? this.item['email'] : null);
    if (this.showSameEmail) {
        this.userForm.get('parentEmail').disable();
    } else {
        this.userForm.get('parentEmail').enable();
    }
  }
}
